import React, { useEffect, useMemo, useRef, useState } from "react";

import { Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
// import { useLead } from "../../../../../context/LeadReport";
import { ValidDate } from "../../../../../utils/DateUtils";
// import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
// import TableChartIcon from "@mui/icons-material/TableChart";
import { useNavigate } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch, useSelector } from "react-redux";
import { fetchStatus } from "../../../../../store/slices/statusSlice";
import {
    setHistoricalStatusRedux,
    setHistoricalYearRedux,
} from "../../../../../store/slices/filterSlice";
import HistoricalDownload from "./HistoricalDownload";
import HistoricaltableL1 from "./HistoricaltableL1";
import { setFilteredReports } from "../../../../../store/slices/filteredDataSlice";
import { setFilteredNavData } from "../../../../../store/slices/LeadreportfilteredSlice";
// import RemoveIcon from '@mui/icons-material/Remove';
import { useCurrencySymbol } from "../../../../../utils/currencyUtils";
import { ChartColumnDecreasing, ChevronDown, TableOfContents } from "lucide-react";
import { useLoggedUser } from "../../../../../utils/useLoggedUser";
import { hasViewOrFullAccess, getExactFeatureAccessLevel } from "../../../../../utils/featureAccessUtils";
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);
const HistoricalData = ({ currentEmployee, hasNoFeatureConfig, userLevel }) => {
    const dispatch = useDispatch();
    const currency = useCurrencySymbol();
    const loggedUser = useLoggedUser()
    const [filteredLeadReportsL1, setFilteredLeadReportsL1] = useState([]);
    const [statuses, setStatuses] = useState([]);

    const canShowGraphs = userLevel === "L0" || hasNoFeatureConfig || !currentEmployee || hasViewOrFullAccess(currentEmployee, "HISTORICAL DATA GRAPHS");
    const canShowFilter = userLevel === "L0" || hasNoFeatureConfig || !currentEmployee || hasViewOrFullAccess(currentEmployee, "HISTORICAL DATA FILTER");

    const downloadAccessLevel = !hasNoFeatureConfig && currentEmployee
        ? (
            getExactFeatureAccessLevel(currentEmployee, "HISTORICAL DATA DOWNLOAD")
            ?? getExactFeatureAccessLevel(currentEmployee, "HISTORICAL DATA GRAPHS")
        )
        : null;
    const isDownloadViewOnly = downloadAccessLevel && String(downloadAccessLevel).trim().toUpperCase() === "VIEW ONLY";

    const { newfilteredReports } = useSelector((state) => state.filteredData);
    const { status } = useSelector((state) => state.status);
    const [showgraph, setShowgraph] = useState(true);
    const handleToggleCard = () => setShowgraph((v) => !v);

    useEffect(() => {
        if (newfilteredReports) {
            setFilteredLeadReportsL1(newfilteredReports);
        }
    }, [newfilteredReports]);

    useEffect(() => {
        dispatch(setFilteredReports());
    }, [dispatch]);

    useEffect(() => {
        dispatch(fetchStatus());
    }, [dispatch]);

    useEffect(() => {
        if (status.length > 0) {
            const updatedStatuses = [...status, { status: "Non Responsive" }];
            setStatuses(updatedStatuses);
        }
    }, [status]);

    const navigate = useNavigate();
    // const { setChartDataArray, setChartAmount } = useLead();

    const [showYearDropdown, setShowYearDropdown] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowYearDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const StatusdropdownRef = useRef(null);
    const [showstatusDropdown, setshowstatusDropdown] = useState(false);
    // Handle clicks outside the dropdown to close it
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                StatusdropdownRef.current &&
                !StatusdropdownRef.current.contains(event.target)
            ) {
                setshowstatusDropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // const finalAmountYearWise = useMemo(() => {
    //   return filteredLeadReportsL1.reduce(
    //     (amount, current) => amount + current.QuotedValue,
    //     0
    //   );
    // }, [filteredLeadReportsL1]);

    // useEffect(() => {
    //   setChartDataArray(filteredLeadReportsL1);
    //   setChartAmount(finalAmountYearWise);
    // }, [
    //   filteredLeadReportsL1,
    //   finalAmountYearWise,
    //   setChartAmount,
    //   setChartDataArray,
    // ]);

    const [historicalTab, setHistoricalTab] = useState("graph");

    const [selectedYears, setSelectedYears] = useState([]); // Default empty (user must select)
    const [selectedStatus, setSelectedStatus] = useState([]);
    const handleYearChange = (event) => {
        const year = Number(event.target.value);

        setSelectedYears((prevSelected) => {
            const updatedYears = prevSelected.includes(year)
                ? prevSelected.filter((y) => y !== year) // Remove if already selected
                : [...prevSelected, year]; // Add if not selected

            dispatch(setHistoricalYearRedux(updatedYears)); // Update Redux state

            return updatedYears;
        });
    };

    const handleStatusChange = (event) => {
        const selectedValue = event.target.value;

        setSelectedStatus((prev) => {
            let updatedStatus;

            if (selectedValue === "Non Responsive" && event.target.checked) {
                // If "Non Responsive" is selected, uncheck everything else
                updatedStatus = ["Non Responsive"];
            } else if (event.target.checked) {
                // If another status is selected, and "Non Responsive" was already selected, remove it
                updatedStatus = prev
                    .filter((stat) => stat !== "Non Responsive")
                    .concat(selectedValue);
            } else {
                // If any checkbox is unchecked, just remove it from the list
                updatedStatus = prev.filter((stat) => stat !== selectedValue);
            }

            dispatch(setHistoricalStatusRedux(updatedStatus));
            return updatedStatus;
        });
    };

    const selectedYearsHistorical = useSelector(
        (state) => state.filters.selectedYearsHistorical
    );
    const selectedStatusHistorical = useSelector(
        (state) => state.filters.selectedStatusHistorical
    );

    useEffect(() => {
        if (
            selectedYearsHistorical !== undefined &&
            selectedYearsHistorical !== null
        ) {
            setSelectedYears(selectedYearsHistorical);
        } else {
            setSelectedYears([]);
        }
    }, [selectedYearsHistorical]);

    useEffect(() => {
        if (
            selectedStatusHistorical !== undefined &&
            selectedStatusHistorical !== null
        ) {
            setSelectedStatus(selectedStatusHistorical);
        } else {
            setSelectedStatus([]);
        }
    }, [selectedStatusHistorical]);

    // const handleYearChange = (event) => {
    //   const year = Number(event.target.value);
    //   setSelectedYears(
    //     (prevSelected) =>
    //       prevSelected.includes(year)
    //         ? prevSelected.filter((y) => y !== year) // Remove if already selected
    //         : [...prevSelected, year] // Add if not selected
    //   );
    // };

    const years = useMemo(() => {
        const allYears = filteredLeadReportsL1
            .map((lead) => new Date(lead.LeadDate).getFullYear())
            .filter((year, index, self) => self.indexOf(year) === index) // Remove duplicates
            .sort((a, b) => b - a); // Sort in descending order (optional)
        return allYears;
    }, [filteredLeadReportsL1]);

    const [historicalDownload, setHistoricalDownload] = useState([]);

    const graphData = useMemo(() => {
        const yearsToInclude =
            selectedYears.length === 0 ? years : selectedYears.map(Number);
        const twoYearsAgo = new Date();
        twoYearsAgo.setFullYear(twoYearsAgo.getFullYear() - 2);

        let firstLeadDate = null;
        let lastLeadDate = null;

        // Step 1: Find the first and last occurrence of a lead across all years
        filteredLeadReportsL1.forEach((lead) => {
            const normalizedDate = ValidDate(lead.LeadDate);
            if (!normalizedDate) return;

            const leadDate = new Date(normalizedDate);

            if (!firstLeadDate || leadDate < firstLeadDate) {
                firstLeadDate = leadDate;
            }
            if (!lastLeadDate || leadDate > lastLeadDate) {
                lastLeadDate = leadDate;
            }
        });

        // If no valid lead dates found, return empty array
        if (!firstLeadDate || !lastLeadDate) return [];

        const allMonths = [];
        const selectedYearsSet = new Set(
            selectedYears.length ? selectedYears.map(Number) : years
        );

        let tempDate = new Date(
            firstLeadDate.getFullYear(),
            firstLeadDate.getMonth(),
            1
        );
        const endDate = new Date(
            lastLeadDate.getFullYear(),
            lastLeadDate.getMonth(),
            1
        );

        while (tempDate <= endDate) {
            // Only include months from selected years
            if (selectedYearsSet.has(tempDate.getFullYear())) {
                const label = `${[
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dec",
                ][tempDate.getMonth()]
                    }\u00A0'${tempDate.getFullYear().toString().slice(-2)}`;

                allMonths.push({
                    label,
                    year: tempDate.getFullYear(),
                    month: tempDate.getMonth() + 1,
                    Won: 0,
                    WonRecurring: 0,
                    Pending: 0,
                    Lost: 0,
                });
            }
            tempDate.setMonth(tempDate.getMonth() + 1); // Move to next month
        }

        // Step 3: Fill in actual data
        filteredLeadReportsL1.forEach((lead) => {
            const normalizedDate = new Date(lead.LeadDate);
            if (!normalizedDate) return;

            const leadDate = new Date(normalizedDate);
            const leadYear = leadDate.getFullYear();
            const leadMonth = leadDate.getMonth() + 1;

            if (!yearsToInclude.includes(leadYear)) return;

            if (selectedStatus.includes("Non Responsive")) {
                if (lead.Status !== "Pending" || lead.Status !== "pending") return;
                if (leadDate >= twoYearsAgo) return;
            } else {
                const isStatusIncluded =
                    selectedStatus.length === 0 ||
                    selectedStatus.some(status => status.toLowerCase() === lead.Status.toLowerCase());
                // const isStatusIncluded =
                //     selectedStatus.length === 0 || selectedStatus.includes(lead.Status);
                if (!isStatusIncluded) return;
            }

            const monthLabel = `${[
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec",
            ][leadMonth - 1]
                }\u00A0'${leadYear.toString().slice(-2)}`;

            let entry = allMonths.find((e) => e.label === monthLabel);
            if (entry) {
                if (selectedStatus.includes("Non Responsive")) {
                    // entry.Won++;
                    // entry.WonRecurring++;
                    entry.Pending++;
                    // entry.Lost++;
                } else {
                    if (lead.Status === "Won" || lead.Status === "won") entry.Won++;
                    else if (lead.Status === "Won Recurring" || lead.Status === "won recurring") entry.WonRecurring++;
                    else if (lead.Status === "Pending" || lead.Status === "pending") entry.Pending++;
                    else if (lead.Status === "Lost" || lead.Status === "lost") entry.Lost++;
                }
            }
        });

        let validFilteredLeads = filteredLeadReportsL1.filter((lead) => {
            const normalizedDate = ValidDate(lead.LeadDate);
            if (!normalizedDate) return false;

            const leadDate = new Date(normalizedDate);
            const leadYear = leadDate.getFullYear();

            if (!yearsToInclude.includes(leadYear)) return false;

            if (selectedStatus.includes("Non Responsive")) {
                if (lead.Status !== "Pending" || lead.Status !== "pending") return false;
                if (leadDate >= twoYearsAgo) return false;
            } else {
                // const isStatusIncluded =
                //     selectedStatus.length === 0 || selectedStatus.includes(lead.Status);
                const isStatusIncluded =
                    selectedStatus.length === 0 ||
                    selectedStatus.some(status => status.toLowerCase() === lead.Status.toLowerCase());
                if (!isStatusIncluded) return false;
            }

            return true;
        });
        // Store the filtered leads in state
        setHistoricalDownload(validFilteredLeads);

        return allMonths;
    }, [filteredLeadReportsL1, selectedYears, selectedStatus, years]);

    const totalQuotedValue = useMemo(() => {
        const yearsToInclude =
            selectedYears.length === 0
                ? years // ✅ Includes all available years
                : selectedYears.map(Number);

        const today = new Date();
        const twoYearsAgo = new Date(today);
        twoYearsAgo.setFullYear(today.getFullYear() - 2);

        const total = filteredLeadReportsL1.reduce((sum, lead) => {
            const normalizedDate = ValidDate(lead.LeadDate);
            if (!normalizedDate) return sum;

            const [year, month, day] = normalizedDate.split("-").map(Number);
            const leadDate = new Date(year, month - 1, day);

            // ✅ Check if lead year is in selectedYears
            if (!yearsToInclude.includes(year)) return sum;

            // ✅ If "Non Responsive" is selected, only include "Pending" leads older than 2 years
            if (selectedStatus.includes("Non Responsive")) {
                if (lead.Status !== "Pending" || leadDate >= twoYearsAgo) return sum;
            } else {
                // ✅ Check if lead status is in selectedStatus (or show all if none selected)
                // const isStatusIncluded =
                //     selectedStatus.length === 0 || selectedStatus.includes(lead.Status);
                const isStatusIncluded =
                    selectedStatus.length === 0 ||
                    selectedStatus.some(status => status.toLowerCase() === lead.Status.toLowerCase());
                if (!isStatusIncluded) return sum;
            }
            // ✅ Add QuotedValue if lead matches filters
            return sum + lead.QuotedValue;
        }, 0);
        return total;
    }, [filteredLeadReportsL1, selectedYears, selectedStatus, years]);

    // const formatNumber = (num) => {
    //     if (!num) return "";
    //     const value = Number(num);
    //     if (value >= 1_000_000_000) {
    //         // Billion or more
    //         const formattedValue = (value / 1_000_000_000).toFixed(1);
    //         return formattedValue.endsWith(".0")
    //             ? `${Math.floor(value / 1_000_000_000)}B`
    //             : `${formattedValue}B `;
    //     } else if (value >= 1_000_000) {
    //         // Million or more
    //         const formattedValue = (value / 1_000_000).toFixed(1);
    //         return formattedValue.endsWith(".0")
    //             ? `${Math.floor(value / 1_000_000)}M`
    //             : `${formattedValue}M `;
    //     }
    //     return new Intl.NumberFormat("en-US").format(value); // Add commas for thousands
    // };

    const countryCode = loggedUser?.countrycode

    const formatNumberByCountry = (num) => {
        if (num === null || num === undefined || num === "") return "";
        const value = Number(num);

        // 🇮🇳 India (+91)
        if (countryCode === "+91") {
            if (value >= 1_00_00_000) {
                const v = value / 1_00_00_000;
                return `${new Intl.NumberFormat("en-IN", { maximumFractionDigits: 1 }).format(v)}Cr`;
            } else if (value >= 1_00_000) {
                const v = value / 1_00_000;
                return `${new Intl.NumberFormat("en-IN", { maximumFractionDigits: 1 }).format(v)}L`;
            }
            return value.toLocaleString("en-IN");
        }

        // 🇺🇸 US (+1)
        if (countryCode === "+1") {
            if (value >= 1_000_000_000) {
                const v = value / 1_000_000_000;
                return `${new Intl.NumberFormat("en-US", { maximumFractionDigits: 1 }).format(v)}B`;
            } else if (value >= 1_000_000) {
                const v = value / 1_000_000;
                return `${new Intl.NumberFormat("en-US", { maximumFractionDigits: 1 }).format(v)}M`;
            }
            return value.toLocaleString("en-US");
        }

        return value.toLocaleString();
    };

    const yAxisCanvasRef = useRef(null);
    const chartRef = useRef(null); // Reference for Chart.js

    useEffect(() => {
        if (yAxisCanvasRef.current && chartRef.current) {
            const canvas = yAxisCanvasRef.current;
            const ctx = canvas.getContext("2d");

            // Clear previous labels
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            // Get Y-axis labels from Chart.js
            const yScale = chartRef.current.scales.y;
            if (!yScale) return;

            const yLabels = yScale.ticks.map((tick) => tick.value); // Extract computed labels
            const canvasHeight = canvas.height;

            // Set styles for text
            ctx.font = "14px Arial";
            ctx.fillStyle = "black";
            ctx.textAlign = "right";

            // Draw Y-axis title (rotated)
            ctx.save();
            ctx.translate(15, canvasHeight / 2);
            ctx.rotate(-Math.PI / 2);
            ctx.fillText("No of Leads", 0, 0);
            ctx.restore();

            // Draw labels from Chart.js on the canvas
            yLabels.forEach((label, index) => {
                const yPos =
                    (1 - index / (yLabels.length - 1)) * (canvasHeight - 40) + 20;
                ctx.fillText(label, 45, yPos);
            });
        }
    }, [graphData]); // Re-run when data updates

    const scrollContainerRef = useRef(null);

    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;

        if (scrollContainer) {
            if (selectedStatus.includes("Non Responsive")) {
                // Find the first bar with actual Pending data
                const firstNonEmptyIndex = graphData.findIndex(
                    (entry) => entry.Pending > 0
                );

                if (firstNonEmptyIndex !== -1) {
                    const targetElement = scrollContainer.children[firstNonEmptyIndex];

                    if (targetElement) {
                        // Smooth scrolling to the first data point
                        scrollContainer.scrollTo({
                            left: targetElement.offsetLeft - 50, // Adjust for padding
                            behavior: "smooth", // Enables smooth scrolling
                        });
                    }
                }
            } else {
                // Default scrolling behavior (scroll to the rightmost)
                scrollContainer.scrollTo({
                    left: scrollContainer.scrollWidth,
                    behavior: "smooth",
                });

                // Prevent excessive right scrolling
                const handleScroll = () => {
                    if (
                        scrollContainer.scrollLeft >=
                        scrollContainer.scrollWidth - scrollContainer.clientWidth
                    ) {
                        scrollContainer.scrollLeft =
                            scrollContainer.scrollWidth - scrollContainer.clientWidth;
                    }
                };

                scrollContainer.addEventListener("scroll", handleScroll);
                return () =>
                    scrollContainer.removeEventListener("scroll", handleScroll);
            }
        }
    }, [graphData, selectedStatus, historicalTab, showgraph]);

    const minBars = 3; // Minimum bars to take full width
    const barWidth = 80; // Width of a single bar
    const totalBars = graphData.length;

    const containerWidth =
        totalBars < minBars ? minBars * barWidth : totalBars * barWidth;

    const datasets = [
        {
            label: "Won",
            data: graphData.map((entry) => (entry.Won > 0 ? entry.Won : undefined)),
            // data: graphData.map((entry) => entry.Won),
            backgroundColor: (context) => {
                const { chart } = context;
                const { ctx, chartArea } = chart;
                if (!chartArea) return "#14b8a6";
                const g = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
                g.addColorStop(0, "#0f766e"); // teal darker bottom
                g.addColorStop(1, "#2dd4bf"); // teal lighter top
                return g;
            },
            stack: "Stack 0",
            borderRadius: 0,
            borderWidth: 0,
            order: 2,
        },
        {
            label: "Won Recurring",
            data: graphData.map((entry) =>
                entry.WonRecurring > 0 ? entry.WonRecurring : null
            ),
            backgroundColor: (context) => {
                const { chart } = context;
                const { ctx, chartArea } = chart;
                if (!chartArea) return "#86efac";
                const g = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
                g.addColorStop(0, "#4ade80"); // light green bottom
                g.addColorStop(1, "#bbf7d0"); // lighter top
                return g;
            },
            stack: "Stack 0",
            borderRadius: 0,
            borderWidth: 0,
            order: 2,
        },
        {
            label: "Pending",
            data: graphData.map((entry) =>
                entry.Pending > 0 ? entry.Pending : null
            ),
            backgroundColor: (context) => {
                const { chart } = context;
                const { ctx, chartArea } = chart;
                if (!chartArea) return "#fbbf24";
                const g = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
                g.addColorStop(0, "#f59e0b"); // orange bottom
                g.addColorStop(1, "#fcd34d"); // yellow top
                return g;
            },
            stack: "Stack 0",
            borderRadius: 0,
            borderWidth: 0,
            order: 2,
        },
        {
            label: "Lost",
            data: graphData.map((entry) => (entry.Lost > 0 ? entry.Lost : null)),
            backgroundColor: (context) => {
                const { chart } = context;
                const { ctx, chartArea } = chart;
                if (!chartArea) return "#ef4444";
                const g = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
                g.addColorStop(0, "#dc2626"); // red bottom
                g.addColorStop(1, "#fca5a5"); // light red top
                return g;
            },
            stack: "Stack 0",
            borderRadius: 0,
            borderWidth: 0,
            order: 2,
        },
    ];

    const historicalNavigationL1 = (Status, monthName, year) => {
        const filteredData = historicalDownload.filter((lead) => {
            // ✅ Convert LeadDate to a standard Date object
            let leadDate = new Date(lead.LeadDate);
            // ✅ Extract month name and year from LeadDate
            let leadMonthName = leadDate.toLocaleString("en-US", { month: "long" });

            let leadYear = leadDate.getFullYear();

            // ✅ Compare Status, Month, and Year
            return (
                lead.Status === Status &&
                leadMonthName === monthName &&
                leadYear === year
            );
        });

        dispatch(setFilteredNavData(filteredData));

        navigate(`/dashboard/lead-report`);
    };


    const handleBarClick = (event, elements) => {
        if (!elements.length) return; // No bar clicked

        const chart = chartRef.current; // Get chart instance
        const datasetIndex = elements[0].datasetIndex; // Dataset index (stack)
        const dataIndex = elements[0].index; // Data index (month/year)

        const dataset = chart.data.datasets[datasetIndex]; // Get dataset
        const Status = dataset.label; // Stack label (Won, Lost, etc.)

        // ✅ Get corresponding month and year from graphData
        const clickedData = graphData[dataIndex];
        const monthNumber = clickedData.month; // e.g., 1 for Jan, 2 for Feb
        const year = clickedData.year; // e.g., 1989, 2024

        // ✅ Convert month number to full name
        const monthName = new Date(year, monthNumber - 1).toLocaleString("en-US", {
            month: "long",
        });

        historicalNavigationL1(Status, monthName, year);
    };

    return (
        <div
            className="relative isolate z-0 flex h-full min-h-0 w-full min-w-0 flex-col overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm"
        >
            <div className="px-4 pt-3">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <button
                            type="button"
                            onClick={handleToggleCard}
                            className="flex shrink-0 items-center justify-center rounded-lg border border-gray-200 bg-white p-1.5 transition hover:bg-gray-50"
                            aria-label={showgraph ? "Collapse" : "Expand"}
                            aria-expanded={showgraph}
                        >
                            <ChevronDown
                                className={`h-4 w-4 text-gray-600 ${showgraph ? "" : "rotate-180"}`}
                                strokeWidth={2}
                            />
                        </button>
                        {historicalTab === "table" && (
                            <button
                                type="button"
                                title="Graph"
                                className="flex shrink-0 items-center justify-center rounded-full bg-blue-600 p-1 text-white transition hover:bg-blue-700"
                                onClick={() => setHistoricalTab("graph")}
                                disabled={!showgraph}
                            >
                                <ChartColumnDecreasing className="h-5 w-5" strokeWidth={2} aria-hidden />
                            </button>
                        )}
                        {historicalTab === "graph" && (
                            <button
                                type="button"
                                title="Table"
                                className="flex shrink-0 items-center justify-center rounded-full bg-blue-600 p-1 text-white transition hover:bg-blue-700"
                                onClick={() => setHistoricalTab("table")}
                                disabled={!showgraph}
                            >
                                <TableOfContents className="h-5 w-5 rotate-180" strokeWidth={2} aria-hidden />
                            </button>
                        )}
                        <h1 className="dashboard-card-title min-w-0 truncate">
                            HISTORICAL DATA
                        </h1>
                    </div>
                    <div className="flex items-center">
                        {(userLevel === "L0" || hasNoFeatureConfig || !currentEmployee || hasViewOrFullAccess(currentEmployee, "HISTORICAL DATA DOWNLOAD")) && (
                            <HistoricalDownload historicalDownload={historicalDownload} isDownloadViewOnly={isDownloadViewOnly} />
                        )}
                    </div>
                </div>
            </div>

            {showgraph && canShowGraphs && (
                <div className="pb-3 px-4 bg-white rounded-bl-lg rounded-br-lg">
                    {/* <div className="p-4 bg-white rounded-lg"> */}
                    <div className="flex flex-col pb-2">
                        {canShowFilter && (
                        <div className="flex flex-wrap justify-between items-center gap-4">
                            <div className="flex w-full items-end gap-4">
                                {/* Year Filter */}
                                <div className="w-[28%]">
                                    <div className="text-xs font-semibold mb-1 text-[#1F2937]">Year</div>
                                    <div
                                        ref={dropdownRef}
                                        className="relative border border-gray-300 rounded-md bg-white"
                                    >
                                        <div className="flex items-center px-3 h-10">
                                            <button
                                                type="button"
                                                onClick={() => setShowYearDropdown(!showYearDropdown)}
                                                className="flex-1 text-left text-xs font-semibold text-[#1F2937] focus:outline-none"
                                            >
                                                {selectedYears.length === 0
                                                    ? "Select Year"
                                                    : selectedYears.join(", ").length <= 20
                                                        ? selectedYears.join(", ")
                                                        : "Multiple"}
                                            </button>
                                            <ExpandMoreIcon
                                                className="text-gray-500 cursor-pointer"
                                                onClick={() => setShowYearDropdown(!showYearDropdown)}
                                            />
                                        </div>

                                        {showYearDropdown && (
                                            <div className="absolute left-0 top-full z-50 w-full bg-white text-sm border border-gray-300 overflow-y-auto shadow-lg max-h-48 mt-1 rounded-md">
                                                {years.map((year) => (
                                                    <label
                                                        key={year}
                                                        className="flex items-center px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            value={year}
                                                            checked={selectedYears.includes(year)}
                                                            onChange={handleYearChange}
                                                            className="mr-2"
                                                        />
                                                        {year}
                                                    </label>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* Status Filter */}
                                <div className="w-[28%]">
                                    <div className="text-xs font-semibold mb-1 text-[#1F2937]">Status</div>
                                    <div
                                        ref={StatusdropdownRef}
                                        className="relative border border-gray-300 rounded-md bg-white"
                                    >
                                        <button
                                            type="button"
                                            onClick={() => setshowstatusDropdown(!showstatusDropdown)}
                                            className="w-full flex justify-between items-center px-3 h-10 text-xs font-semibold text-[#1F2937] focus:outline-none"
                                        >
                                            <span className="truncate">
                                                {selectedStatus.length === 0
                                                    ? "All Status"
                                                    : selectedStatus.join(", ").length < 20
                                                        ? selectedStatus.join(", ")
                                                        : "Multiple"}
                                            </span>
                                            <ExpandMoreIcon className="text-gray-500" />
                                        </button>

                                        {showstatusDropdown && (
                                            <div className="absolute left-0 top-full z-50 w-full bg-white text-sm border border-gray-300 shadow-lg max-h-48 overflow-y-auto overflow-x-hidden rounded-md mt-1">
                                                {[...statuses]
                                                    .sort((a, b) => {
                                                        const order = [
                                                            "Won",
                                                            "Won Recurring",
                                                            "Pending",
                                                            "Lost",
                                                            "Non Responsive",
                                                        ];
                                                        const indexA = order.indexOf(a.status);
                                                        const indexB = order.indexOf(b.status);
                                                        if (indexA === -1 && indexB === -1) return 0;
                                                        if (indexA === -1) return 1;
                                                        if (indexB === -1) return -1;
                                                        return indexA - indexB;
                                                    })
                                                    .map((status) => (
                                                        <label
                                                            key={status.id}
                                                            className="flex items-center px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                                        >
                                                            <input
                                                                type="checkbox"
                                                                value={status.status}
                                                                checked={selectedStatus.includes(
                                                                    status.status
                                                                )}
                                                                onChange={handleStatusChange}
                                                                className="mr-2"
                                                            />
                                                            <span className="text-sm">{status.status}</span>
                                                        </label>
                                                    ))}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* Spacer
                                <div className="w-[25%]"></div> */}

                                <div className="w-[44%] flex justify-end items-end">
                                    <div
                                        className="translate-y-4 rounded-lg px-5 py-3 text-center"
                                        style={{ backgroundColor: "#E6F4EA" }}
                                    >
                                        <div className="text-[11px] font-semibold tracking-wide text-gray-500">
                                            TOTAL QUOTED VALUE
                                        </div>
                                        <div className="mt-1 text-xl font-semibold text-[#157f3d]">
                                            {currency}{formatNumberByCountry(totalQuotedValue)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        )}
                    </div>

                    {/* Legend */}
                    <div className="flex flex-wrap items-center gap-6 px-1 pb-2 mb-4">
                        <div className="flex items-center gap-2 text-xs font-semibold text-gray-600">
                            <span className="h-3 w-3 rounded-full" style={{ backgroundColor: "#2dd4bf" }} />
                            Won
                        </div>
                        <div className="flex items-center gap-2 text-xs font-semibold text-gray-600">
                            <span className="h-3 w-3 rounded-full" style={{ backgroundColor: "#86efac" }} />
                            Won Recurring
                        </div>
                        <div className="flex items-center gap-2 text-xs font-semibold text-gray-600">
                            <span className="h-3 w-3 rounded-full" style={{ backgroundColor: "#fbbf24" }} />
                            Pending
                        </div>
                        <div className="flex items-center gap-2 text-xs font-semibold text-gray-600">
                            <span className="h-3 w-3 rounded-full" style={{ backgroundColor: "#f87171" }} />
                            Lost
                        </div>
                    </div>

                    {historicalTab === "graph" ? (
                        <div className="min-h-0 dm:h-[21.7rem] lg:h-[21.2rem] xl:h-[21.7rem]">
                            {/* <div className="lg:h-[29.4rem] xl:h-[29.8rem] bg-orange-300"> */}
                            <div className="flex w-full h-full">
                                {/* <div className="flex -rotate-90 h-7 bg-red-500 justify-center align-middle items-center">
                                     No of Leads
                                </div> */}
                                <div className="w-7 flex items-center justify-center relative">
                                    <div className="absolute transform -rotate-90 whitespace-nowrap text-sm font-semibold text-gray-700">
                                        LEADS
                                    </div>
                                </div>

                                {/* Chart area */}
                                <div className="flex-1 overflow-hidden">
                                    <div
                                        ref={scrollContainerRef}
                                        className="overflow-x-auto h-full"
                                    >
                                        <div
                                            style={{
                                                width: `${containerWidth}px`,
                                                minWidth: "100%",
                                                height: "100%",
                                                display: "flex",
                                                justifyContent:
                                                    totalBars < minBars ? "flex-start" : "center",
                                            }}
                                        >
                                            {graphData.length > 0 ? (
                                                <Bar
                                                    ref={chartRef}
                                                    data={{
                                                        labels: graphData.map((entry) => entry.label),
                                                        datasets: datasets,
                                                    }}
                                                    options={{
                                                        responsive: true,
                                                        maintainAspectRatio: false,
                                                        elements: {
                                                            bar: {
                                                                minBarLength: 0,
                                                                borderWidth: 0,
                                                                bar: { clip: false },
                                                                line: { clip: false },
                                                            },
                                                        },
                                                        plugins: {
                                                            legend: { display: false },
                                                            tooltip: {
                                                                enabled: true,
                                                                callbacks: {
                                                                    title: () => null,
                                                                    label: (tooltipItem) =>
                                                                        `${tooltipItem.dataset.label}: ${Math.round(
                                                                            tooltipItem.raw
                                                                        )}`,
                                                                },
                                                            },
                                                        },
                                                        scales: {
                                                            x: {
                                                                display: true,
                                                                beginAtZero: true,
                                                                stacked: true,
                                                                ticks: {
                                                                    autoSkip: false,
                                                                    color: "black",
                                                                    font: {
                                                                        family: "Arial",
                                                                        size: 12,
                                                                        weight: "bold",
                                                                    },
                                                                    maxRotation: 45,
                                                                    minRotation: 45,
                                                                },
                                                                grid: { display: false },
                                                                categoryPercentage: 0.8,
                                                                barPercentage: 0.7,
                                                            },

                                                            y: {
                                                                display: false,
                                                                stacked: true,
                                                                grid: { drawTicks: false, display: false },
                                                                ticks: {
                                                                    display: true,
                                                                    color: "#A0A4A5",
                                                                    autoSkip: false,
                                                                    stepSize: 1,
                                                                    beginAtZero: true,
                                                                    precision: 0,
                                                                    maxTicksLimit: 10,
                                                                },
                                                            },
                                                            yTrend: {
                                                                position: "right",
                                                                display: false,
                                                                min: 0,
                                                                suggestedMin: 0,
                                                                suggestedMax: Math.ceil(
                                                                    Math.max(
                                                                        ...graphData.map(
                                                                            (entry) =>
                                                                                entry.Won +
                                                                                entry.WonRecurring +
                                                                                entry.Pending +
                                                                                entry.Lost
                                                                        )
                                                                    )
                                                                ),
                                                            },
                                                        },
                                                        barThickness: 45,
                                                        onClick: handleBarClick,
                                                    }}
                                                />
                                            ) : (
                                                <div className="flex justify-center items-center w-full h-full text-gray-500">
                                                    <p className="text-lg">No data available</p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="h-[21rem] w-full mt-4">
                            <HistoricaltableL1
                                historicalDownload={historicalDownload}
                                selectedStatus={selectedStatus}
                            />
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}

export default HistoricalData